module.exports = __webpack_public_path__ + "img/icon8.42ac4526.jpg";